import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { HelmetProvider } from 'react-helmet-async'

window.addEventListener(
  'error',
  (event) => {
    const isChunkError =
      event?.message?.includes('Loading chunk') ||
      event?.message?.includes('ChunkLoadError') ||
      (event?.target?.tagName === 'SCRIPT' && event?.target?.src?.includes('.chunk.js'))

    if (isChunkError) {
      const hasRefreshed = JSON.parse(sessionStorage.getItem('chunk_retry_refreshed') || 'false')

      if (!hasRefreshed) {
        sessionStorage.setItem('chunk_retry_refreshed', 'true')
        window.location.reload()
      }
    }
  },
  true // 使用 capture 階段攔截 script 載入錯誤
)

// 2. 頁面成功載入後，重置重新整理標記
window.addEventListener('load', () => {
  sessionStorage.setItem('chunk_retry_refreshed', 'false')
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  // <React.StrictMode>
  <HelmetProvider>
    <App />
  </HelmetProvider>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
